import { Component, OnInit } from '@angular/core';
import { CommonUtilitiesService } from "../common-utilities.service";
import { constants } from "../constants";
//jquery var
import * as $ from 'jquery';
declare var $: any;
@Component({
  selector: 'app-uso911',
  templateUrl: './uso911.component.html',
  styleUrls: ['./uso911.component.scss']
})
export class Uso911Component implements OnInit {

  constructor(public LANG:CommonUtilitiesService) { }

  ngOnInit() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
  }

  openPdf(){
    window.open(constants.URL_PDF_USO_911, '_blank')
  }

}
